/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MessageDto } from '../../models/message-dto';

export interface MessageGet$Plain$Params {
  InsurerId?: string;
  MessageId?: number;
  MessageName?: string;
}

export function messageGet$Plain(http: HttpClient, rootUrl: string, params?: MessageGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MessageDto>>> {
  const rb = new RequestBuilder(rootUrl, messageGet$Plain.PATH, 'get');
  if (params) {
    rb.query('InsurerId', params.InsurerId, {});
    rb.query('MessageId', params.MessageId, {});
    rb.query('MessageName', params.MessageName, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MessageDto>>;
    })
  );
}

messageGet$Plain.PATH = '/v1/Message/Get';
